import { render, staticRenderFns } from "./NoteViewer.vue?vue&type=template&id=0ad70e75&scoped=true"
import script from "./NoteViewer.vue?vue&type=script&lang=js"
export * from "./NoteViewer.vue?vue&type=script&lang=js"
import style0 from "./NoteViewer.vue?vue&type=style&index=0&id=0ad70e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad70e75",
  null
  
)

export default component.exports